import {CSSProperties} from "react";

export enum IconSize {
    xxs = 5,
    xs = 15,
    sm = 20,
    md = 30,
    lg = 40,
    xl = 50
}

export interface IconProps {
    size: IconSize | number | string
    colour?: string
    style?: CSSProperties
    className?: string
}
